module.exports = __webpack_public_path__ + "static/img/close_icon.e9bfff56.png";